// extracted by mini-css-extract-plugin
export default {"title":"_55de85de78","inner_title":"_7e9dac8607","charge_btn":"_8cda6a962a"};